
import { createContext, useMemo } from 'react';
import { TSelectedDetail } from '../../../../../../Types/MasterDetailTypes';
import { MeQuery } from '../Queries/MeQuery/_QueryTypes/MeQuery';
import { IResourceInfo } from '../Utils/KalenderTypes';
import { INyAktivitetInitialValues } from './SchedulerComponent/Utils/NyAktivitetInitialValues';

export interface ISchedulerContext {
  currentViewName: string | undefined;
  onSelectDetail?: (id: TSelectedDetail) => void;
  overView: boolean | undefined;
  appointmentLimitMonthView: Record<string, number>;
  dayScaleRecordMonthView: Record<string, boolean>;
  changeMooreDayView: (data: any) => void;
  setNyAktivitetInitialValues: (
    values: INyAktivitetInitialValues | undefined
  ) => void;
  resources: IResourceInfo[];
  redDays: Date[];
  bookingGroups: MeQuery | undefined;
  onOverViewChange?: (overView: boolean) => void;
  onNavigate: ((direction: 'forward' | 'back' | undefined) => any) | null;
  setOnNavigate: (
    onNavigate: (direction: 'forward' | 'back' | undefined) => any
  ) => void;
  tooltipOnHover: (tooltip: boolean) => void;
  showOutlookBookings: boolean | undefined;
  setShowOutlookBookings?: (hideOutlookBookings: boolean) => void;
}

const defaultValues: ISchedulerContext = {
  currentViewName: '',
  overView: undefined,
  appointmentLimitMonthView: {},
  dayScaleRecordMonthView: {},
  changeMooreDayView: (data: any) => {},
  setNyAktivitetInitialValues: () => {},
  resources: [],
  redDays: [],
  bookingGroups: undefined,
  onOverViewChange: () => {},
  onNavigate: (direction: 'forward' | 'back' | undefined) => {},
  setOnNavigate: (
    onNavigate: (direction: 'forward' | 'back' | undefined) => any
  ) => {},
  tooltipOnHover: () => {},
  showOutlookBookings: undefined,
  setShowOutlookBookings: () => {},
};

export const SchedulerContext = createContext<ISchedulerContext>(defaultValues);

export const SchedulerContextProvider: React.FC<
  React.PropsWithChildren<ISchedulerContext>
> = props => {
  const value: ISchedulerContext = useMemo(
    () => ({
      currentViewName: props.currentViewName,
      onSelectDetail: props.onSelectDetail,
      overView: props.overView,
      appointmentLimitMonthView: props.appointmentLimitMonthView,
      dayScaleRecordMonthView: props.dayScaleRecordMonthView,
      changeMooreDayView: props.changeMooreDayView,
      setNyAktivitetInitialValues: props.setNyAktivitetInitialValues,
      resources: props.resources,
      redDays: props.redDays,
      bookingGroups: props.bookingGroups,
      onOverViewChange: props.onOverViewChange,
      onNavigate: props.onNavigate,
      setOnNavigate: props.setOnNavigate,
      tooltipOnHover: props.tooltipOnHover,
      showOutlookBookings: props.showOutlookBookings,
      setShowOutlookBookings: props.setShowOutlookBookings,
    }),
    [
      props.currentViewName,
      props.onSelectDetail,
      props.overView,
      props.appointmentLimitMonthView,
      props.dayScaleRecordMonthView,
      props.changeMooreDayView,
      props.setNyAktivitetInitialValues,
      props.resources,
      props.redDays,
      props.bookingGroups,
      props.onOverViewChange,
      props.onNavigate,
      props.setOnNavigate,
      props.tooltipOnHover,
      props.showOutlookBookings,
      props.setShowOutlookBookings,
    ]
  );

  return (
    <SchedulerContext.Provider value={value}>
      {props.children}
    </SchedulerContext.Provider>
  );
};
